import { PresenceContext } from "motion/react";
import { FC, PropsWithChildren } from "react";

import { DEFAULT_EDIT_PAGE_TRANSITION_DURATION } from "@ryde/shared";

import { AnimationPageWrapperStyled } from "./animated-page.styled";
import { useAnimatedPage } from "./use-animated-page";

interface IAnimatedPage extends PropsWithChildren {
  durationSeconds?: number;
}

export const AnimatedPage: FC<IAnimatedPage> = ({
  children,
  durationSeconds = DEFAULT_EDIT_PAGE_TRANSITION_DURATION,
}) => {
  const { variants, transition, contentPresenceContext } = useAnimatedPage({
    durationSeconds,
  });

  return (
    <AnimationPageWrapperStyled
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={transition}
    >
      <PresenceContext.Provider value={contentPresenceContext}>
        {children}
      </PresenceContext.Provider>
    </AnimationPageWrapperStyled>
  );
};
